// import {GroupsAddOrEditDialog} from '@/views/settings/Groups/GroupsAddOrEditDialog.vue'; //globalnie zarejestrowany w libie
import CategoryManage from '@/views/settings/Categories/CategoryManage.vue';
import MachinesManage from '@/views/Machines/MachinesManage.vue';
import ToolsManage from '@/views/Tools/ToolsManage.vue';
import ManageStaffModal from '@/views/Staff/ManageStaffModal.vue';
// import CompanyAddOrEditDialog from '@/views/settings/Companies/CompanyAddOrEditDialog.vue'; //TODO sprawdzić czy dziala z tego komponentu
import { CompanyAddOrEditDialog } from 'signalo-vue-settings-companies-view';
import EquipmentTypeManage from '@/views/settings/EquipmentTypes/EquipmentTypeManage.vue';
import CostCenterManage from '@/views/settings/CostCenters/CostCenterManage.vue';
import CrewManageDialog from '@/views/settings/Crews/CrewManageDialog.vue';
import ShiftsSchemaManage from '@/views/settings/Shifts/ShiftsSchemaManage.vue';
// import ProductManage from '@/views/settings/Products/ProductManage.vue';
import ProductManage from '@/views/temp/ManageProductDialog.vue';
import PartsAddOrEdit from '@/views/Parts/PartsAddOrEdit.vue';
import { ManageChecklistDialog } from 'signalo-vue-settings-checklists-view';

export default {
    // GroupsAddOrEditDialog,
    CategoryManage,
    MachinesManage,
    ToolsManage,
    ManageStaffModal,
    CompanyAddOrEditDialog,
    EquipmentTypeManage,
    CostCenterManage,
    CrewManageDialog,
    ShiftsSchemaManage,
    ProductManage,
    PartsAddOrEdit,
    ManageChecklistDialog
};
